import $ from 'jquery';

function Model(options){
    this.fetchUrl = options.fetch;
    this.deleteUrl = options.delete;
    this.saveUrl = options.save;
    this.attributes = {};
}

Model.prototype.get = function(key){
    return this.attributes[key];
};

Model.prototype.fetch = function(){
    return $.getJSON(this.fetchUrl).done((data) =>{
        this.attributes = data;
    });
};

Model.prototype.delete = function(){
    return $.ajax({
        url:this.deleteUrl,
        type: 'DELETE'
    });
};

Model.prototype.save = function(value, paymentMethod){
  if (!paymentMethod) {
    paymentMethod = 'check'
  }

  // var dfd = jQuery.Deferred();
  // setTimeout(function() {
  //   dfd.resolve(JSON.stringify({
  //     result: 1
  //   }))
  // }, 2000)
  // return dfd.promise()

  return $.post(this.saveUrl, {value:value, paymentMethod});
};

export default Model;